import { globalVariables } from "helper/globalVariables";
import { useForm } from "react-hook-form";
import { TextInput } from "shared/Components/textInput";
import { searchDetailResolver } from "validators/UserValidation";
import "../modules.css";
import { useEffect, useRef, useState } from "react";
import Accordion from "shared/Components/accordian";
import { useNavigate } from "react-router-dom";
import { PopUpMessages } from "shared/Components/popUpMessages";
import { useMediaQuery } from "react-responsive";
import { client } from "helper/apolloConfig";
import { createTrialCalendarMutation } from "redux/features/hostSlice/addTrialSlice/addTrialGql";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  setHostDetails,
  setSearchDetails,
  setTrialDetails,
} from "redux/features/hostSlice/addTrialSlice/addTrialSlice";
import { StepsHeader } from "shared/Components/stepsHeader";
import { SectionHeading } from "../common/SectionHeading";
import { TextButton } from "shared/Components/textButton";
import { BottomButtons } from "shared/Components/bottomButtons";
import MultiSelectWithSearch from "shared/Components/multiSelectWithSearch";
import { LEVEL_DROPDOWN_DATA } from "helper/utility";
import {
  updateHostOwnTrialCalendarMutation,
  updateTrialCalendarByAdminMutation,
} from "redux/features/trialCalendar/trialCalendarGql";

export const SearchDetails = (props) => {
  const { onTapPrevious, currentPage, saveSearchDetails, isEdit, isAdmin, id } =
    props || {};
  const [checkValidation, setCheckValidation] = useState(false);
  const [accordianIndex, setAccordianIndex] = useState(isEdit ? null : 0);
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const modalRef = useRef();
  const { auth } = useSelector((state) => state);
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ query: "(max-width: 1024px)" });
  const isSmallMobile = useMediaQuery({ query: "(max-width: 630px)" });
  const [apiData, setApiData] = useState({
    title: "",
    desc: "",
    type: "pending",
  });
  const [searchDetail, setSearchDetail] = useState([
    {
      title: globalVariables.searchDetail,
      levelNovice: "",
      elements: "",
      searchName: "",
      entryFee: 0,
    },
  ]);
  const elements = [
    { id: 1, label: globalVariables.birchSIT, level: "SIT" },
    { id: 2, label: globalVariables.aniseSIT, level: "SIT" },
    { id: 3, label: globalVariables.cloveSIT, level: "SIT" },
    {
      id: 4,
      label: globalVariables.noviceContainers,
      level: globalVariables.novice,
    },
    {
      id: 5,
      label: globalVariables.noviceExteriors,
      level: globalVariables.novice,
    },
    {
      id: 6,
      label: globalVariables.noviceFastFinds,
      level: globalVariables.novice,
    },
    {
      id: 7,
      label: globalVariables.noviceInteriors,
      level: globalVariables.novice,
    },
    { id: 8, label: globalVariables.noviceSolo, level: globalVariables.novice },
    {
      id: 9,
      label: globalVariables.advancedContainers,
      level: globalVariables.advanced,
    },
    {
      id: 10,
      label: globalVariables.advancedExteriors,
      level: globalVariables.advanced,
    },
    {
      id: 11,
      label: globalVariables.advancedFastFinds,
      level: globalVariables.advanced,
    },
    {
      id: 12,
      label: globalVariables.advancedInteriors,
      level: globalVariables.advanced,
    },
    {
      id: 13,
      label: globalVariables.advancedSolo,
      level: globalVariables.advanced,
    },
    {
      id: 14,
      label: globalVariables.excellentContainers,
      level: globalVariables.excellent,
    },
    {
      id: 15,
      label: globalVariables.excellentExteriors,
      level: globalVariables.excellent,
    },
    {
      id: 16,
      label: globalVariables.excellentFastFinds,
      level: globalVariables.excellent,
    },
    {
      id: 17,
      label: globalVariables.excellentInteriors,
      level: globalVariables.excellent,
    },
    {
      id: 18,
      label: globalVariables.excellentSolo,
      level: globalVariables.excellent,
    },
    {
      id: 19,
      label: globalVariables.premierShortTrial,
      level: globalVariables.premierShortTrial,
    },
    {
      id: 20,
      label: globalVariables.premierFullTrial,
      level: globalVariables.premierFullTrial,
    },
    // {
    //   id: 20,
    //   label: globalVariables.premierShortTrial,
    //   level: globalVariables.premier,
    // },
  ];
  const noviceDropdownData = LEVEL_DROPDOWN_DATA;

  useEffect(() => {
    if (saveSearchDetails) {
      getSearchDetails();
    }
  }, [saveSearchDetails]);

  const getSearchDetails = () => {
    if (auth?.addTrialReducer?.searchDetails) {
      const searchDetails = auth?.addTrialReducer?.searchDetails;

      if (searchDetails.length) {
        setSearchDetail(searchDetails);
      } else {
        setSearchDetail([
          {
            title: globalVariables.searchDetail,
            levelNovice: "",
            elements: "",
            searchName: "",
            entryFee: 0,
          },
        ]);
      }
    }
  };

  const { handleSubmit } = useForm({
    resolver: searchDetailResolver,
    defaultValues: searchDetail?.[accordianIndex],
  });

  const onHandleSubmit = () => {
    setCheckValidation(true);
    const searchData = searchDetail?.[accordianIndex];
    if (
      searchData.levelNovice &&
      searchData.elements &&
      searchData.searchName &&
      searchData.entryFee > 0
    ) {
      setAccordianIndex(null);
    }
  };

  const onAddSearchDetail = () => {
    for (let index = 0; index < searchDetail.length; index++) {
      const searchData = searchDetail?.[index];
      if (
        !(
          searchData.levelNovice &&
          searchData.elements &&
          searchData.searchName &&
          searchData.entryFee > 0
        )
      ) {
        setAccordianIndex(index);
        setCheckValidation(true);
        return;
      }
    }
    // checkValidationForm();
    setSearchDetail([
      ...searchDetail,
      {
        title: globalVariables.searchDetail,
        levelNovice: "",
        elements: "",
        searchName: "",
      },
    ]);
    setAccordianIndex(searchDetail.length);
    setCheckValidation(false);
    setTimeout(() => {
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: "smooth",
      });
    }, 100);
  };

  const onChangeIndex = (index) => {
    setCheckValidation(false);
    setAccordianIndex(index === null ? 0 : index);
  };

  const onChangeSearchName = (value) => {
    if (!value?.label) return;
  
    setSearchDetail((prev) => {
      const updated = [...prev];
      const current = { ...updated[accordianIndex] };
  
      const count = prev.filter((item) => item?.title?.includes(value.label))
        .length;
  
      const newTitle = count ? `${value.label} ${count + 1}` : value.label;
  
      updated[accordianIndex] = {
        ...current,
        searchName: newTitle,
        title: newTitle,
        elements: value.label,
        levelNovice: value.level,
      };
  
      return updated;
    });
  };

  const onChangeEntryFee = (e) => {
    const searchDetailsArr = [...searchDetail];
    const obj = { ...searchDetailsArr[accordianIndex] };
    obj.entryFee = e.target.value;
    searchDetailsArr[accordianIndex] = obj;
    setSearchDetail(searchDetailsArr);
  };

  const checkValidationForm = () => {
    for (let index = 0; index < searchDetail.length; index++) {
      const searchData = searchDetail?.[index];
      if (
        !(
          searchData.levelNovice &&
          searchData.elements &&
          searchData.searchName &&
          searchData.entryFee > 0
        )
      ) {
        setAccordianIndex(index);
        setCheckValidation(true);
        return;
      }
    }
  };

  const onGoNext = async () => {
    for (let index = 0; index < searchDetail.length; index++) {
      const searchData = searchDetail?.[index];
      if (
        !(
          searchData.levelNovice &&
          searchData.elements &&
          searchData.searchName &&
          searchData.entryFee > 0
        )
      ) {
        setAccordianIndex(index);
        setCheckValidation(true);
        return;
      }
    }
    setLoading(true);

    const { hostDetails, trialDetails } = auth?.addTrialReducer || {};

    const payload = {
      host: {
        hostName: hostDetails?.hostName,
        contactAddress: hostDetails?.contactAddress,
        city: hostDetails?.city,
        trialSecretaryName: hostDetails?.trialSecretaryName,
        state: hostDetails?.state,
        trialSecretaryEmail: hostDetails?.trialSecretaryEmailAddress,
        zip: hostDetails?.zip,
        paypalEmail: hostDetails?.hostPaypalEmail,
        paypalPaymentLink: hostDetails?.paypalPaymentLink,
      },
      trial: {
        trialName: trialDetails?.trialName,
        trialLocationName: trialDetails?.trialLocationName,
        trialLocationAddress: trialDetails?.trialLocationAddress,
        city: trialDetails?.city,
        state: trialDetails?.state,
        zip: trialDetails?.zip,
        timezone: trialDetails?.timeZone,
        trialDate: trialDetails.trialDate instanceof Date
          ? trialDetails.trialDate.toISOString()
          : new Date(trialDetails.trialDate).toISOString(),
        openDate: trialDetails.openDate instanceof Date
          ? trialDetails.openDate.toISOString()
          : new Date(trialDetails.openDate).toISOString(),
        closeDate: trialDetails.closeDate instanceof Date
          ? trialDetails.closeDate.toISOString()
          : new Date(trialDetails.closeDate).toISOString(),
        cutoffDate: trialDetails.cutoffDate instanceof Date
          ? trialDetails.cutoffDate.toISOString()
          : new Date(trialDetails.cutoffDate).toISOString(),
        trialFile: trialDetails?.image,
        description: trialDetails?.description,
        notes: trialDetails?.notes,
        noOfJudge: parseInt(trialDetails?.numberOfJudges),
        maxEntries: parseInt(trialDetails?.maxEntries),
        trialImages: trialDetails?.uploadImage,
        judgeAuthId: trialDetails?.addedJudges?.map((e) => e?.authId),
        status: "Open",
      },
      searches: searchDetail.map((search) => ({
        level: search.levelNovice,
        element: search.elements,
        searchName: search.searchName,
        entryFee: parseInt(search.entryFee),
      })),
    };
    const variables = { data: payload };

    if (isEdit) {
      variables.trialCalendarId = parseInt(id);
    }
  
    try {
      const result = await client.mutate({
        mutation: isEdit
          ? isAdmin
            ? updateTrialCalendarByAdminMutation
            : updateHostOwnTrialCalendarMutation
          : createTrialCalendarMutation,
        variables: variables,
      });
      const res = isEdit
        ? isAdmin
          ? result?.data?.updateTrialCalendarByAdmin
          : result?.data?.updateHostOwnTrialCalendar
        : result?.data?.createTrialCalendar;
      if (res) {
        dispatch(setHostDetails(null));
        dispatch(setTrialDetails(null));
        dispatch(setSearchDetails([]));
        setLoading(false);
        modalRef.current.openModal();
        setApiData({
          ...apiData,
          title: globalVariables.success,
          desc: isEdit ? globalVariables.trialUpdatedSuccessfully : globalVariables.trialSubmittedSuccessfully,
          type: "success",
        });
      }
    } catch (err) {
      modalRef.current.openModal();
      setApiData({
        ...apiData,
        title: globalVariables.error,
        desc: err.message,
        type: "pending",
      });
      setLoading(false);
    }
  };

  const updatedAccordianData = searchDetail.map(item => ({
    ...item,
    title: item.searchName
  }));

  const onRemove = (index) => {
    const searchDetailsArr = [...searchDetail];
    searchDetailsArr.splice(index, 1);

    setSearchDetail(searchDetailsArr);
  };

  const onCloseModal = () => {
    if(apiData.type == "success") {
      navigate("/admin/manage/trial");
    }
  };

  const tapPrevious = () => {
    dispatch(setSearchDetails(searchDetail));
    onTapPrevious?.();
  };

  const renderAccordianBody = () => {
    return (
      <div>
        <form onSubmit={handleSubmit((d) => console.log("d===", d))}>
          <MultiSelectWithSearch
            label={globalVariables.elements}
            errorMsg={
              searchDetail?.[accordianIndex]?.elements
                ? ""
                : checkValidation
                ? globalVariables.elementsRequired
                : ""
            }
            options={elements}
            placeholder={globalVariables.elements}
            onChange={(option) => {
              onChangeSearchName(option?.[0]);
            }}
            defaultSelectedOptions={
              elements.filter(
                (e) => e.label === searchDetail?.[accordianIndex]?.elements
              )?.[0]
            }
          />
          <div className="mt-5" />
          <TextInput
            placeholder={globalVariables.searchName}
            errorMsg={
              searchDetail?.[accordianIndex]?.searchName
                ? ""
                : checkValidation
                ? globalVariables.searchNameRequired
                : ""
            }
            onChange={onChangeSearchName}
            value={searchDetail?.[accordianIndex]?.searchName}
            label={globalVariables.searchName}
            disabled
          />
          <div className="mt-5" />
          <TextInput
            placeholder={globalVariables.entryFee}
            errorMsg={
              searchDetail?.[accordianIndex]?.entryFee > 0
                ? ""
                : checkValidation
                ? globalVariables.entryFeeRequired
                : ""
            }
            onChange={onChangeEntryFee}
            value={searchDetail?.[accordianIndex]?.entryFee}
            label={globalVariables.entryFee}
            type="number"
          />
          {/* <div className="mt-5 flex justify-end">
            <TextButton onClick={onHandleSubmit} label={globalVariables.save} />
          </div> */}
        </form>
      </div>
    );
  };

  return (
    <>
      <div className="flex justify-centerl flex-col items-center mb-8">
        <StepsHeader
          step={3}
          labels={[
            globalVariables.hostDetails,
            globalVariables.trialDetails,
            globalVariables.searchDetails,
          ]}
        />
        <SectionHeading heading={globalVariables.searchDetails} />
        <div className="max-[400px]:w-[100%] pb-[20px]">
          <Accordion
            items={updatedAccordianData}
            children={renderAccordianBody()}
            onChangeIndex={onChangeIndex}
            defaultIndex={accordianIndex}
            hasRemove
            onRemove={onRemove}
            hasLabel
          />
            <div className="flex justify-end">
              <button
                className="border rounded-md bg-purple-800 p-3 text-white hover:bg-lightBlue"
                onClick={onAddSearchDetail}
              >
                {globalVariables.addAnotherSearch}
              </button>
            </div>
        </div>
      </div>
      <BottomButtons
        outlineLabel={globalVariables.previous}
        fullLabel={currentPage == 2 ? globalVariables.save : globalVariables.next}
        onTapYes={onGoNext}
        onTapNo={tapPrevious}
        position={"fixed"}
        dogSign={true}
        extraClass={
          isMobile
            ? isSmallMobile
              ? "h-[80px] w-[118vw]"
              : "h-[80px] w-[108vw] pr-0"
            : "dog-signup-bb-h"
        }
        disabled={loading}
      />
     
      <PopUpMessages
        type={apiData.type}
        title={apiData.title}
        desc={apiData.desc}
        ref={modalRef}
        onCloseModal={onCloseModal}
      />
    </>
  );
};
